export const Protected = () => {
  return <h1>You should only be able to see this as a logged-in user.</h1>;
};
